import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/sidebar.css";
import "@/styles/modal-design.css";
import App from "@/App";
import { initErrorMonitoring } from "@/observability";

initErrorMonitoring();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
/* deploy-fix 1779983850 */
